import { render, staticRenderFns } from "./BtnConvenio.vue?vue&type=template&id=36f5b49a&"
import script from "./BtnConvenio.vue?vue&type=script&lang=js&"
export * from "./BtnConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports